/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Collaborator,
    CollaboratorFromJSON,
    CollaboratorFromJSONTyped,
    CollaboratorToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface CollaboratorsListResponse
 */
export interface CollaboratorsListResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof CollaboratorsListResponse
     */
    msg: string;
    /**
     * 
     * @type {Array<Collaborator>}
     * @memberof CollaboratorsListResponse
     */
    entries: Array<Collaborator>;
}

export function CollaboratorsListResponseFromJSON(json: any): CollaboratorsListResponse {
    return CollaboratorsListResponseFromJSONTyped(json, false);
}

export function CollaboratorsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CollaboratorsListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entries': ((json['entries'] as Array<any>).map(CollaboratorFromJSON)),
    };
}

export function CollaboratorsListResponseToJSON(value?: CollaboratorsListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entries': ((value.entries as Array<any>).map(CollaboratorToJSON)),
    };
}


